/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Meta_DescriptionInputs */

const id_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi game gratis dari Epic Games Store.`)
};

const ms_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layari permainan percuma dari Epic Games Store.`)
};

const da_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemse gratis spil fra Epic Games Store.`)
};

const de_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchstöbern Sie kostenlose Spiele im Epic Games Store.`)
};

const en_us2_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse free games from the Epic Games Store.`)
};

const es_es2_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora juegos gratis de la Epic Games Store.`)
};

const es_mx2_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora juegos gratis de la Epic Games Store.`)
};

const fil_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-browse ng mga libreng laro mula sa Epic Games Store.`)
};

const fr_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourez les jeux gratuits de l'Epic Games Store.`)
};

const it_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia i giochi gratuiti dell'Epic Games Store.`)
};

const hu_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böngéssz az ingyenes játékok között az Epic Games Store-ból.`)
};

const nl_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blader door gratis games van de Epic Games Store.`)
};

const no_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bla gjennom gratis spill fra Epic Games Store.`)
};

const pl_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj darmowe gry z Epic Games Store.`)
};

const pt_br2_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore jogos grátis da Epic Games Store.`)
};

const pt_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore jogos grátis da Epic Games Store.`)
};

const ro_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorează jocurile gratuite din Epic Games Store.`)
};

const fi_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaa ilmaisia pelejä Epic Games Storesta.`)
};

const sv_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bläddra bland gratis spel från Epic Games Store.`)
};

const vi_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt game miễn phí từ Epic Games Store.`)
};

const tr_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki ücretsiz oyunlara göz atın.`)
};

const cs_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházejte hry zdarma z Epic Games Store.`)
};

const bg_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разгледайте безплатни игри от Epic Games Store.`)
};

const ru_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотр бесплатных игр из Epic Games Store.`)
};

const uk_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляньте безкоштовні ігри з Epic Games Store.`)
};

const ar_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح الألعاب المجانية من Epic Games Store.`)
};

const hi_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store से मुफ़्त गेम ब्राउज़ करें।`)
};

const th_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเกมฟรีจาก Epic Games Store`)
};

const ja_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の無料ゲームを閲覧。`)
};

const zh_cn2_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览来自Epic游戏商城的免费游戏。`)
};

const zh_hant1_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瀏覽來自Epic遊戲商城的免費遊戲。`)
};

const ko_freebies_meta_description = /** @type {(inputs: Freebies_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 무료 게임을 둘러보세요.`)
};

/**
* | output |
* | --- |
* | "Browse free games from the Epic Games Store." |
*
* @param {Freebies_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_meta_description = /** @type {((inputs?: Freebies_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_meta_description(inputs)
	if (locale === "ms") return ms_freebies_meta_description(inputs)
	if (locale === "da") return da_freebies_meta_description(inputs)
	if (locale === "de") return de_freebies_meta_description(inputs)
	if (locale === "en-US") return en_us2_freebies_meta_description(inputs)
	if (locale === "es-ES") return es_es2_freebies_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_freebies_meta_description(inputs)
	if (locale === "fil") return fil_freebies_meta_description(inputs)
	if (locale === "fr") return fr_freebies_meta_description(inputs)
	if (locale === "it") return it_freebies_meta_description(inputs)
	if (locale === "hu") return hu_freebies_meta_description(inputs)
	if (locale === "nl") return nl_freebies_meta_description(inputs)
	if (locale === "no") return no_freebies_meta_description(inputs)
	if (locale === "pl") return pl_freebies_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_meta_description(inputs)
	if (locale === "pt") return pt_freebies_meta_description(inputs)
	if (locale === "ro") return ro_freebies_meta_description(inputs)
	if (locale === "fi") return fi_freebies_meta_description(inputs)
	if (locale === "sv") return sv_freebies_meta_description(inputs)
	if (locale === "vi") return vi_freebies_meta_description(inputs)
	if (locale === "tr") return tr_freebies_meta_description(inputs)
	if (locale === "cs") return cs_freebies_meta_description(inputs)
	if (locale === "bg") return bg_freebies_meta_description(inputs)
	if (locale === "ru") return ru_freebies_meta_description(inputs)
	if (locale === "uk") return uk_freebies_meta_description(inputs)
	if (locale === "ar") return ar_freebies_meta_description(inputs)
	if (locale === "hi") return hi_freebies_meta_description(inputs)
	if (locale === "th") return th_freebies_meta_description(inputs)
	if (locale === "ja") return ja_freebies_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_meta_description(inputs)
	return ko_freebies_meta_description(inputs)
});
export { freebies_meta_description as "freebies.meta.description" }